var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownlaodReportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1078_3368",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3973 8.26459L9.95731 9.70457V3.0638C9.95731 2.64253 9.61264 2.29785 9.19137 2.29785C8.7701 2.29785 8.42542 2.64253 8.42542 3.0638V9.70457L6.97778 8.26459C6.67906 7.96587 6.19651 7.96587 5.89779 8.26459C5.75437 8.40769 5.67376 8.60197 5.67376 8.80458C5.67376 9.00719 5.75437 9.20147 5.89779 9.34457L8.64754 12.0943C8.94626 12.393 9.42881 12.393 9.72753 12.0943L12.4773 9.34457C12.776 9.04585 12.776 8.56331 12.4773 8.26459C12.1786 7.96587 11.696 7.96587 11.3973 8.26459ZM14.553 13.7871V9.95733C14.553 9.53606 14.8977 9.19138 15.319 9.19138C15.7402 9.19138 16.0849 9.53606 16.0849 9.95733V14.553C16.0849 15.3956 15.3955 16.0849 14.553 16.0849H3.82973C2.98719 16.0849 2.29784 15.3956 2.29784 14.553V9.95733C2.29784 9.53606 2.64251 9.19138 3.06378 9.19138C3.48506 9.19138 3.82973 9.53606 3.82973 9.95733V13.7871C3.82973 14.2083 4.17441 14.553 4.59568 14.553H13.7871C14.2083 14.553 14.553 14.2083 14.553 13.7871Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1078_3368)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3827,
    height: 18.3827,
    fill: "#231A3D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownlaodReportIcon);
export default __webpack_public_path__ + "static/media/downlaodReportIcon.259ca82f5240c884f10f13418ec94772.svg";
export { ForwardRef as ReactComponent };